/**
 * Sets correct Content-Type header based on request name
 */

export const setHeaderContentType = (headers: Headers, endpoint: string) => {
  const applicationJsonEndpoints = [
    "updateClient",
    "createClient",
    "updateFTPSetting",
    "createFTPSetting",
    "updateServicePackages",
    "createServicePackages",
    "createUser",
    "updateUser",
    "updateProjectStatus",
    "createProductionCompany",
    "updateProductionCompany",
    "createVersion",
    "updateVersion",
    "createAdvertiser",
    "updateAdvertiser",
    "createBrand",
    "updateBrand",
    "createIndustry",
    "updateIndustry",
    "createMail",
    "updateMail",
    "createMailTemplate",
    "updateMailTemplate",
    "createSupportMessage",
    "updateSupportMessage",
    "createLead",
    "updateLead",
    "createOrder",
    "updateOrder",
    "createReDeliveryOrder",
    // The re-delivery admin drawer's Save (spec-13 Task 7.6). Missing from this list until
    // 2026-08-06: the PUT went out as x-www-form-urlencoded with a JSON body, Web API bound an
    // all-null view model, and AdminPut silently saved NULLs over the client info — while the UI
    // toasted "Successfully updated".
    "updateReDeliveryOrder",
    "updateReDeliveryOrderSelection",
    "updateReDeliveryOrderCustomer",
    "sentMessage",
    "shareVideo",
    "createAdvertiserShort",
    "createBrandShort",
    "createProductionCompanyShort",
    "createMediaCompanyShort",
    "updateProject",
    "createProject",
    "updateUserData",
    "updateNotificationsSettings",
    "changePassword",
    "updateClientUser",
    "setHouseNumber",
    "sendToFTP",
    "sendToBroadcasters",
    "sendForCustomerApproval",
    "changeInternalNumber",
    "changeCampaignNumber",
    "createAndSendProject",
    "setFileUploaded",
    "deleteUploadedFile",
    "deleteUser",
    "createUserFromSettings",
    "updateUserFromSettings",
    "sendInitPasswordEmail",
    "adminSendInitPasswordEmail",
    "changeProjectStatus",
    "createDelivery",
    "saveFTPSettingsByClient",
    "createNewActivityLogEntry",
    "getLeads",
    "forgotPasswordByUserName",
    "forgotPasswordByEmail",
    "createTranslation",
    "updateTranslation",
    "deleteTranslation",
    "updateAndSendProject",
    "updateHouseNumber",
    "exportPostProductionReport",
    "addRecipient",
    "updateProjectShort",
    "shareDelivery",
    "shareCampaign",
    "adAgencyShortEdit",
    "getGeneralVideoAdReport",
    "bulkChargeReports",
    // spec-45 (2026-09-18, found in the Task-18 dev acceptance): the preview's `{ Year, Month }`
    // body went out as x-www-form-urlencoded "[object Object]", Web API answered 400, and the
    // Auto Charge dialog never opened. The four row actions (ChargeRow / IssueInvoice / VerifyRow /
    // ReleaseLock) are bodyless POSTs and need no entry.
    "bulkChargePreview",
    "updateReport",
    "exportClientReport",
    "exportGeneralReport",
    "updateReportComment",
    "updateGeneralComment",
    "sendMailWithTemplate",
    "getRegistrationClientToken",
    "registerClient",
    "registerUser",
    "forgotPasswordByUserName",
    "forgotPasswordByEmail",
    "resetUserPassword",
    "updateGlobalSettings",
    "updateNotificationSettings",
    "updateVideoGuide",
    "createVideoGuide",
  ];

  if (applicationJsonEndpoints.some((ep) => ep === endpoint)) {
    headers.set("Content-Type", "application/json; charset=UTF-8");
    headers.set("Accept", "application/json");
  } else {
    headers.set(
      "Content-Type",
      "application/x-www-form-urlencoded; charset=UTF-8"
    );
  }
};
